import DetailsSVG from '../../home/icons/pds.svg';
import AddressSVG from '../../home/icons/address.svg';
import EducationSVG from '../../home/icons/edu.svg';
import GuaridainSvg from '../../home/icons/guardian.svg';
import UploadSVG from '../../home/icons/uploads.svg';

export const focusErrClass = 'border-[#FFCACB]';
export const showErrClass = 'text-[#ED1A1A]';
export const currentYear = new Date().getFullYear(); // Get the current year dynamically

export const menuItems = [
  {
    label: 'Personal Details', icon: DetailsSVG, url: '/user/profile', index: 1,
  },
  {
    label: 'Addresses', icon: AddressSVG, url: '/user/profile', index: 2,
  },
  {
    label: 'Educational Details', icon: EducationSVG, url: '/user/profile', index: 3,
  },
  {
    label: "Guardian's Details", icon: GuaridainSvg, url: '/user/profile', index: 4,
  },
  {
    label: 'Manage Your Uploads', icon: UploadSVG, url: '/user/profile', index: 5,
  },
];

export const customerSupportQueryList = [
  {
    label: 'General Query',
  },
  {
    label: 'Technical',
  },
  {
    label: 'Online Support',
  },
  {
    label: 'Offline Support',
  },
  {
    label: 'Dispatch Related',
  },

  {
    label: 'Test Series',
  },
  {
    label: 'Billing',
  },
  {
    label: 'Others',
  },
];
export const educationList = [
  { lablel: 'Doctorate or higher' },
  { lablel: 'Master’s degre' },
  { lablel: 'Bachelor’s degree' },
  { lablel: 'Diploma' },
  { lablel: 'Secondary education' },
  { lablel: 'Primary education' },
];

export const fileMaxSizeImage = 1 * 1024 * 1024; // 1MB;
export const fileMaxSizePDF = 2 * 1024 * 1024; // 2MB;
export const fileMaxSizeImageText = '1MB';
export const fileMaxSizePDFText = '2MB';
export const stepSuccessMsg = 'Your details have been updated successfully.';

export const checkIsPaidLegacy = (keyLegacyPaid, keyModernPaid) => {
  if (keyLegacyPaid && !keyModernPaid) {
    return true;
  }
  return false;
};

export const checkIsPaidModern = (keyLegacyPaid, keyModernPaid) => {
  if (!keyLegacyPaid && keyModernPaid) {
    return true;
  }
  return false;
};

export const checkIsPaidLegacyAndModern = (keyLegacyPaid, keyModernPaid) => {
  if (keyLegacyPaid && keyModernPaid) {
    return true;
  }
  return false;
};
export const invalidValues = ['NA', null, undefined, ''];
